import { IConfig, FagClient } from '../../../api';

const fagClient = new FagClient(new IConfig());

export const fetchSubjects = () => fagClient.get();